<script setup>
import { computed, toRef } from 'vue';
import { useLinkPreview } from 'dashboard/composables/useLinkPreview';

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
});

const { preview } = useLinkPreview(toRef(props, 'url'));

// O cartao mostra o endereco como ele e, com o www — e o que o WhatsApp
// escreve na primeira e na ultima linha de um link sem previa.
const host = computed(() => {
  try {
    return new URL(props.url).hostname;
  } catch (error) {
    return props.url;
  }
});
const title = computed(() => preview.value?.title || host.value);
// Sem titulo nem descricao da pagina, o meio do cartao e o proprio endereco.
const description = computed(() => preview.value?.description || props.url);

const openLink = () => {
  window.open(props.url, '_blank', 'noopener,noreferrer');
};
</script>

<template>
  <!-- Aceleres -- cartao do link como no WhatsApp: titulo, descricao e
       dominio acima do texto da mensagem. So aparece depois que a previa
       chega; sem ela a bolha fica exatamente como era. -->
  <!-- Aceleres 2026-08-21: a margem direita fixa mora no proprio cartao para
       ter um unico dono e permanecer em 5px tanto no envio quanto na recepcao. -->
  <!-- Aceleres 2026-08-18: o cartao NAO traz cor de fundo. Ela depende de a
       bolha ser recebida ou enviada, e quem sabe isso e o Base.vue — recebida
       fica no cinza claro, enviada no verde. Ele ja alcanca este cartao pelo
       gancho `acl-link-preview`; a cor vai por `linkPreviewToneClass`.
       Escrever um fundo aqui criaria um segundo dono da mesma medida — era o
       `bg-[#d5f3cf]` fixo que pintava de verde tambem o link recebido, dentro
       da bolha branca. -->
  <!-- A classe mobile vence a regra antiga que ocultava este cartao em
       public/aceleres-overrides.css, sem tocar no estilo web. -->
  <button
    type="button"
    class="acl-link-preview mr-[5px] flex min-w-0 flex-col gap-1 rounded-lg p-2 text-left max-md:[.message-bubble-container_.acl-text-bubble_&]:!flex"
    :data-aceleres-external-url="url"
    @click.stop="openLink"
  >
    <span class="line-clamp-2 text-[0.9375rem] font-semibold leading-snug">
      {{ title }}
    </span>
    <span class="line-clamp-2 text-[0.9375rem] leading-snug opacity-70">
      {{ description }}
    </span>
    <span class="truncate text-[0.9375rem] leading-snug opacity-70">
      {{ host }}
    </span>
  </button>
</template>
